import { createElement, memo, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './CurrentPosition.scss';
import '../CitySelection.scss';
import Image from '@hfe/max-image';
import { getImage } from '../../../utils/utils';
import { photos } from '../../../res/constants';
import { Actions } from '../../../store';
function CurrentPosition(props) {
    const refreshCurrentCity = useCallback(() => {
        // console.log('refreshCurrentCity');
        props.dispatchEvent({
            type: Actions.refreshCurrentCity
        });
    }, []);
    return <View>
      <View className="current-position-top-text-container">
        <Text className="city-selection-little-gray-text">当前位置</Text>
        <View className="current-position-refresh-container" onClick={refreshCurrentCity}>
          <Image className="current-position-little-icon" source={getImage(photos.REFRESH_ICON)}/>
          <Text className="current-position-blue-text">刷新定位</Text>
        </View>
      </View>
      <View className="city-selection-city-name-container current-position-city-name-margin" onClick={() => {
        props.emitCity({
            id: props.locationCity.value,
            name: props.locationCity.label
        });
    }}>
        <Text className="city-selection-city-name">{props.locationCity.label}</Text>
      </View>
      <View className="city-selection-short-divider"/>
    </View>;
}
export default memo(CurrentPosition);
